import { render } from "./WalletInstructions.vue?vue&type=template&id=f437a0e8&scoped=true"
import script from "./WalletInstructions.vue?vue&type=script&lang=js"
export * from "./WalletInstructions.vue?vue&type=script&lang=js"

import "./WalletInstructions.vue?vue&type=style&index=0&id=f437a0e8&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f437a0e8"]])

export default __exports__